// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"79f462b9","732":"c1ef2776","977":"21704d4e"}[chunkId] + ".chunk.js";
};